export { default } from './Checkbox';


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/rc-checkbox/es/index.js
// module id = 1289
// module chunks = 0